export const GET_REPORT_BY_DISTRIBUTOR_LIST_START = "GET_REPORT_BY_DISTRIBUTOR_LIST_START";
export const GET_REPORT_BY_DISTRIBUTOR_LIST_SUCCESS = "GET_REPORT_BY_DISTRIBUTOR_LIST_SUCCESS";
export const GET_REPORT_BY_DISTRIBUTOR_LIST_FAILURE = "GET_REPORT_BY_DISTRIBUTOR_LIST_FAILURE";